var selectioCtrl = document.querySelector(".store-selection-ctrl-mobile"),
  selectionList = document.querySelector(".store-selecetion-popup-mobile .store-selection-list-country"),
  selectionListItems = document.querySelectorAll(".store-selecetion-popup-mobile .store-selection-list-item-mobile"),
  storeName = document.querySelector("#store--name-country-mob"),
  storeCurrency = document.querySelector(".store-currency"),
  storeSelectionButton = document.querySelector(".store-selecetion-popup-mobile .store-selection-popup--button"),
  storeURL = "self",
  visitingFrom = "UK",
  visitingCur = "GBP",
  visitingflag = "";
(modalClose = document.querySelector(
  ".store-selecetion-popup-mobile .store-selection-popup--close"
)),
  (flagClass = "");

var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam != -1) {
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "none";
} 
// if (urlParam != -1) {
//   var queryString = window.location.search;
//   var urlParams = new URLSearchParams(queryString);
//   let store = urlParams.get("redirectFrom");
//   store = store.replace("%20", "");
//   localStorage.setItem("visitingFrom", store);
//   localStorage.setItem("storeChecked", "true");
// }



function showVisitingFromMobile() {
  var text = localStorage.getItem("visitingFrom");
  console.log(text);
  if (text != null) {
  const currentCountries = document.querySelectorAll(".visiting-from--text .current-country");
  const storeCountries = document.querySelectorAll(".store-country");
  const allCountryClasses = ["au", "gbp", "nz", "int", "usd", "sgd", "euro", "europe"];

  currentCountries.forEach(el => {
    allCountryClasses.forEach(cls => el.classList.remove(cls));
  });
  storeCountries.forEach(el => {
   allCountryClasses.forEach(cls => el.classList.remove(cls));
  });

  switch (text.trim()) {
    case "Australia":
      currentCountries.forEach(el => {
        el.classList.add("au");
        el.innerText = "AUS";
      });
      storeCountries.forEach(el => {
        el.classList.add("au");
        el.innerText = "Australia";
        document.querySelector('.countrynameselect').innerText = "Australia";
      });
      $(".store-selection-list-item.au").hide();
      visitingCur = "AUD";
      storeSelectionButton.innerText = `Go to Australia`;
      visitingFrom = "Australia";
      break;

    case "United Kingdom":
      currentCountries.forEach(el => {
        el.classList.add("gbp");
        el.innerText = "UK";
      });
      storeCountries.forEach(el => {
        el.classList.add("gbp");
        el.innerText = "United Kingdom";
        document.querySelector('.countrynameselect').innerText = "United Kingdom";
      });
      $(".store-selection-list-item.gbp").hide();
      visitingCur = "GBP";
      $(".countrynameselect").html("United Kingdom");
      storeName.classList.add("store--name", 'gbp');
      visitingFrom = "United Kingdom";
      break;

    case "New Zealand":
      currentCountries.forEach(el => {
        el.classList.add("nz");
        el.innerText = "NZ";
      });
      storeCountries.forEach(el => {
        el.classList.add("nz");
        el.innerText = "New Zealand";
        document.querySelector('.countrynameselect').innerText = "New Zealand";
      });
      $(".store-selection-list-item.nz").hide();
      visitingCur = "NZD";
      storeSelectionButton.innerText = `Go to New Zealand`;
      storeName.classList.add("store--name", 'nz');
      visitingFrom = "New Zealand";
      break;

    case "International":
      currentCountries.forEach(el => {
        el.classList.add("int");
        el.innerText = "INT";
      });
      storeCountries.forEach(el => {
        el.classList.add("int");
        el.innerText = "International";
        document.querySelector('.countrynameselect').innerText = "International";
      });
      $(".store-selection-list-item.int").hide();
      visitingCur = "USD";
      storeName.classList.add("store--name", 'int');
      visitingFrom = "International";
      break;

    case "United States":
      currentCountries.forEach(el => {
        el.classList.add("usd");
        el.innerText = "USA";
      });
      storeCountries.forEach(el => {
        el.classList.add("usd");
        el.innerText = "United States";
        document.querySelector('.countrynameselect').innerText = "United States";
      });
      $(".store-selection-list-item.us").hide();
      visitingCur = "USD";
      storeName.classList.add("store--name", 'usa');
      visitingFrom = "United States";
      break;

  

    case "The Netherlands":
      currentCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "NL";
      });
      storeCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "Netherlands";
        document.querySelector('.countrynameselect').innerText = "Netherlands";
      });
      $(".store-selection-list-item.euro").hide();
      visitingCur = "EUR";
      storeSelectionButton.innerText = `Go to Netherlands`;
      storeName.classList.add("store--name", 'euro');
      visitingFrom = "Netherlands";
      break;
    case "Netherlands":
      currentCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "NL";
      });
      storeCountries.forEach(el => {
        el.classList.add("euro");
        el.innerText = "Netherlands";
        document.querySelector('.countrynameselect').innerText = "Netherlands";
      });
      $(".store-selection-list-item.euro").hide();
      visitingCur = "EUR";
      storeSelectionButton.innerText = `Go to Netherlands`;
      storeName.classList.add("store--name", 'euro');
      visitingFrom = "Netherlands";
      break;  

    case "Europe":
      currentCountries.forEach(el => {
        el.classList.add("europe");
        el.innerText = "EU";
      });
      storeCountries.forEach(el => {
        el.classList.add("europe");
        el.innerText = "Europe";
        document.querySelector('.countrynameselect').innerText = "Europe";
      });
      $(".store-selection-list-item.europe").hide();
      visitingCur = "EUR";
      storeName.classList.add("store--name", 'europe');
      visitingFrom = "Europe";
      break;
  }
} else {
    document
      .querySelectorAll(
        ".store-selecetion-popup .visiting-from--text .current-country"
      )
      .forEach(function (el) {
        el.classList.add("uk");
      });
    document
      .querySelectorAll(
        ".store-selecetion-popup .visiting-from--text .current-country"
      )
      .forEach(function (el) {
        el.innerText = "UK";
      });
    document
      .querySelectorAll(".store-selecetion-popup .store-country")
      .forEach(function (el) {
        el.classList.add("uk");
      });
    document
      .querySelectorAll(".store-selecetion-popup .store-country")
      .forEach(function (el) {
        el.innerText = "United Kingdom";
      });

    document.querySelector('.countrynameselect').innerText = "United Kingdom";

    $(".store-selecetion-popup .store-selection-list-item.uk").hide();
    visitingCur = "GBP";
    storeName.classList.add("store--name", 'gbp');
    visitingFrom = "United Kingdom";
  }
}

function rebuildSelectionList(current) {
  selectionListItems.forEach(function (el) {
    if (current == el) {
      el.style.display = "none";
    } else {
      el.style.display = "block";
    }
  });
}

function showSelectionPopupMobile() {
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "flex";
}

selectioCtrl.addEventListener("click", function () {
  if (selectionList.classList.contains("is-open")) {
    selectionList.classList.remove("is-open");
  } else {
    selectionList.classList.add("is-open");
  }
});

selectionListItems.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionList.classList.remove("is-open");
    storeName.classList = "";
    flagClass = item.classList[1];
    storeName.innerText = item.innerText;
    storeName.classList.add("store--name", flagClass);
     
    visitingFrom = item.innerText;
    visitingCur = item.getAttribute("data-currency");
    visitingflag = item.getAttribute("data-flag");
    storeSelectionButton.innerText = `Go to ${item.innerText}`;
    storeCurrency.innerText = `${visitingCur}`;
    rebuildSelectionList(item);
    storeName.classList.add(visitingflag);
    console.log(flagClass);
  });
});

storeSelectionButton.addEventListener("click", function () {
  if (storeURL == "self") {
    document.querySelector(".store-selecetion-popup-mobile").style.display = "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    showVisitingFrom();
  } else {
    window.location.href = `${storeURL}?redirectFrom=${visitingFrom}`;
  }

  
  if(visitingCur == 'AUD' || visitingCur == 'NZD'){
   console.log(visitingCur) 
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumi.com.au/?redirectFrom=${visitingFrom}`;
  }else if(visitingCur == 'USD' || visitingCur == 'INT' || visitingCur == 'SGD'){
   console.log(visitingCur) 
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumiorganic.com/?redirectFrom=${visitingFrom}`;
  }else{
    document.querySelector(".store-selecetion-popup").style.display = "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", "United Kingdom");
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "none";
});


$(document).ready(function () {
  $(".openpopupmobile").click(function () {
    showSelectionPopupMobile();
  });
  

});
document.addEventListener('showVisitingFromMobile', () => {
    showVisitingFromMobile();
});